// Default React, useState and Material Components
import React, { useState } from "react";
import { Breadcrumbs, Button, Box, CircularProgress, Grid, IconButton, InputAdornment, TextField, Typography } from "@mui/material";
import { Link } from 'react-router-dom';

// Importing Custom Services
import axios from "axios";
import ApiService from "../../../Services/ApiService";
import ErroHandling from "../../../Services/ErrorHandling";
import GetMenuService from "../../../Services/GetMenuService";

// Importing Custom Components
import SideDrawer from "../../../UIComponent/Drawer";
import DataTable from "../../../UIComponent/DataTable";
import BaseLayout from "../../../UIComponent/BaseLayout";
import AlertDialog from "../../../UIComponent/AlertDialog";
import { toasterSuccess, toasterError } from '../../../UIComponent/Toaster/index';

// Importing Add & Edit Components
import AddEditCurrency from "./AddEditCurrency";

// Import Fluent UI Icons
import { AddIcon, ChevronRightSmallIcon, ClearIcon, SearchIcon } from "@fluentui/react-icons-mdl2";

// Importing useStyles and Styles
import useStyles from "../ManageData.styles";

const Currency = (props) => {

  // Declaration of States and Component Variables Start Here
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [reload, setReload] = useState(false);
  const [formData, setFormData] = useState([]);
  const [selected, SetSelected] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState();
  const [allCurrency, setAllCurrency] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openDelete, setOpenDelete] = useState(false);
  const [state, setState] = useState({ right: false });
  const [startSearch, setStartSearch] = useState(false);
  const [isAllSelected, setIsSelected] = useState(false);
  const [crudState, setCrudState] = React.useState(false);
  const [deleteBtnLoadinng, setDeleteBtnLoadinng] = useState(false);
  const [deleteCurrencyData, setDeleteCurrencyData] = useState(null);
  const [sorting, setSorting] = useState({ sortBy: "", isAscending: false });
  const [menuPermission, setMenuPermission] = useState({ allowEdit: true, allowDelete: true, });
  const [access, setAccess] = React.useState({ allowEdit: false, allowDelete: false, allowView: false })
  // Declaration of States and Component Variables End Here

  // Declaration of React Hooks Start Here
  React.useEffect(() => {
    GetMenuService(16, function (err, res) {
      if (res) {
        // console.log(res.data)
        setAccess(res.data)
      } else {
        toasterError(err)
      }
    })
  }, [])
  React.useEffect(() => {
    if (searchValue == "" || searchValue == null || searchValue == undefined) { searchUser('') }
    else { searchUser(searchValue) }
  }, [sorting]);
  
  React.useEffect(() => {
    if (searchValue == "" || searchValue == null || searchValue == undefined) {
      searchUser('')
    } else { searchUser(searchValue) }
  }, [page, reload, rowsPerPage]);

  const toggleDrawer = (open, mode) => (event, item) => {
    if (mode === "Delete") {
      setDeleteCurrencyData(item);
      setOpenDelete(true);
    } else {
      setFormData(item);
      // console.log("EditItem", item)
      setState({ ...state, right: open, formData: item });
      setCrudState(mode);
    }
    
  };
  // Declaration of React Hooks End Here

  // Assigning Colums and UI Props
  const columns = [
    { id: "name", label: "Currency", minWidth: 200, width: "25%", sorting: false },
    { id: "description", label: "Description", minWidth: 400, width: "70%", sorting: false, truncate: 90, tooltipWithTruncate: true }
  ];

// This function handles the keyup event
const handleKeyUp = (event) => {
  // If backspace is pressed and target element is not a button
  if ((event.keyCode === 8 || event.which === 8) && event.target.nodeName !== "BUTTON") {
    // If search value is empty, get currency data
    if (searchValue.length === 0) { getCurrencyData(); }
  }
  // If enter is pressed and target element is not a button
  if (
    (event.keyCode === 13 || event.which === 13) && event.target.nodeName !== "BUTTON") {
    // Set total count to 0
    setTotalCount(0);
    // Set page to 0
    setPage(0);
    // Set start search to true
    setStartSearch(true)
    // Search user with the value of the target element
    searchUser(event.target.value);
  }
};

// This function is used to get currency data from the API
const getCurrencyData = () => {
   // Set loading to true
    setLoading(true);
    // If reload is true, set it to false
    if (reload) { setReload(false); }
    // Create an array of parameters for the API call
    let prt = [`pageNumber=${page + 1}`, `pageSize=${rowsPerPage}`];
    // Call the API and handle the response
    ApiService.search("managedata/GetCurrencyDetails?", {}, prt)
      .then((res) => {
        // If the response status is 200, set the result to allCurrency, set loading to false and set totalCount to the response data's totalCount
        if (res.status === 200) {
          let result = Array.isArray(res.data) ? res.data : res.data.data || [];
          setAllCurrency(result);
          setLoading(false);
          setTotalCount(res.data.totalCount);

        } else { 
          // Else, call toasterError with the response data and set loading to false
          toasterError(`${res.data}`); setLoading(false);
         }
      })
      .catch((err) => {
         // Handle any errors by calling ErroHandling and passing in the error and a callback function
        ErroHandling(err, function (res) {
          toasterError(res)
        })
      });
  };

  // Function for Delete Currency
  const deleteCurrency = () => {
    // Set loading state of delete button to true
    setDeleteBtnLoadinng(true);
    // Get data for deleting currency
    let data = deleteCurrencyData;
    // Make a GET request to check if currency is mapped with any job
    axios.get(process.env.React_App_baseUrl + "managedata/IsCurrencyMapped", {
      headers: {
        id: data.id,
        'Authorization': localStorage.getItem("token") ? "Bearer " + localStorage.getItem("token") : null
      },

    }
    ).then((res) => {
      // If request is successfu
      if (res.data == false) {
        axios.post(process.env.React_App_baseUrl + "managedata/DeleteCurrency", null, {
          headers: {
            id: data.id, 'Authorization': localStorage.getItem("token") ? "Bearer " + localStorage.getItem("token") : null
          }
        }).then((res) => {
          if (res.status === 200) {
            // Show success message
            toasterSuccess("Currency deleted successfully");
             // Get updated currency data
            getCurrencyData();
            // Set loading state of delete button to false
            setDeleteBtnLoadinng(false);
             // Close delete modal
            setOpenDelete(false);
          } else {
            // Show error message
            toasterError("Somthing went wrong");
             // Close delete modal
            setOpenDelete(false);
            // Set loading state of delete button to false
            setDeleteBtnLoadinng(false);
          }
        });
      } else {
        // Show error message
        toasterError('Cannot delete Currency, as job(s) available with the currency that you are trying to delete.')
         // Close delete modal
        setOpenDelete(false);
        // Set loading state of delete button to false
        setDeleteBtnLoadinng(false);
      }
    }
    )
      .catch(err => {
        // Handle errors
        ErroHandling(err, function (res) {
          toasterError(res)
          setOpenDelete(false);
          setDeleteBtnLoadinng(false);
        })

      });
  };

  // Function for Global Search
  const globalSearch = (value) => { setSearchValue(value); };

 // Function to search for a user based on the filter value
const searchUser = (filterValue) => {
  // Set loading to true
  setLoading(true);
  // Create an array of parameters
  let prt = [`pageNumber=${page + 1}`, `pageSize=${rowsPerPage}`];
  // Call the ApiService to search for the user
  ApiService.search("managedata/GetCurrencyDetails?",
    { searchText: encodeURIComponent(filterValue) }, prt
  )
    .then((res) => {
      // If the response status is 200, set the search result and total count
      if (res.status === 200) {
        let searchResult = Array.isArray(res.data) ? res.data : res.data.data || [];
        setAllCurrency(searchResult);
        setLoading(false);
        setTotalCount(res.data.totalCount);
      } else {
        // Else, call the toasterError function with the response data
        toasterError(`${res.data}`); setLoading(false);
      }
    })
    .catch((err) => {
      // Call the ErroHandling function with the error and a callback function
      ErroHandling(err, function (res) {
        toasterError(res)
      })
      // Set loading to false
      setLoading(false);
    });
};

  return (
    // Page Layout Start Here
    <Box>
      <Grid container maxWidth justifyContent="right" alignItems="center">

        {/* Breadcrumbs Menu Start Here */}
        <Grid item xs={12} sm={12} md={6} className="page-title">
          <h2>Currency</h2>
          <Breadcrumbs
            separator={<ChevronRightSmallIcon className={classes.breadCrumbsIcon} />} aria-label="breadcrumb" className="custom-breadcrumb">
            <Link underline="hover" color="inherit" to={{ pathname: "/app/ownership-changes/source-management" }}>Home</Link>
            <Link underline="hover" color="inherit" to={{ pathname: "/app/commodity" }}>Manage Data</Link>
            <Typography color="text.primary">Currency</Typography>
          </Breadcrumbs>
        </Grid>
        {/* Breadcrumbs Menu End Here */}

        {/* Main Buttons Start Here */}

        <Grid item xs={12} sm={12} md={6}>
          <Grid container spacing={2} justifyContent="flex-end" alignItems="center">
            <Grid item xs={"auto"}>
              {(access.allowEdit) ? <>
                <Button onClick={toggleDrawer(true, "Add")} variant="contained" color="accent2" startIcon={<AddIcon style={{ fontSize: 16 }} />}>
                  Add Currency
                </Button>
              </> : null
              }
            </Grid>
          </Grid>
        </Grid>
        {/* Main Buttons End Here */}

        {/* Baselayout Start Here */}
        <Grid item xs={12}>
          <BaseLayout>
            <Box className={classes.addBorder}>

              {/* Search Option and Total Count Start Here */}
              <Grid item xs={12} className={classes.tableTopPart}>
                <Grid container alignItems="center" justifyContent="left" spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      id="input-with-icon-textfield"
                      className={classes.searchByKeyword}
                      value={searchValue}
                      placeholder="Search by Keyword"
                      onKeyUp={handleKeyUp}
                      onChange={(e) => globalSearch(e.target.value)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon className={classes.searchIcon} />
                          </InputAdornment>
                        ),
                      }}
                      variant="standard"
                    />
                    {searchValue ? (
                      <IconButton
                        aria-label="Add"
                        className={classes.serchByClear}
                        onClick={() => {
                          setSearchValue("");
                          getCurrencyData();
                        }}
                      >
                        <ClearIcon style={{ fontSize: 10 }} />
                      </IconButton>
                    ) : ("")}
                  </Grid>
                  <Grid item xs={12} sm={6} textAlign="right">
                    <Typography variant="subtitle2">
                      Total Records: <span className={classes.totalRecord}>{totalCount}</span>
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              {/* Search Option and Total Count End Here */}

              {/* Commodity Table /> */}
              <Grid item xs={12}>
                <DataTable
                  className={classes.removeBorder}
                  loading={isLoading}
                  rows={allCurrency ? allCurrency : []}
                  columns={columns}
                  page={page}
                  setPage={(data) => {
                    setPage(data);
                    setReload(true);
                  }}
                  rowsPerPage={rowsPerPage}
                  setRowsPerPage={(data) => {
                    setRowsPerPage(data);
                    setReload(true);
                  }}
                  totalCount={totalCount}
                  isAllSelected={isAllSelected}
                  setIsSelected={setIsSelected}
                  selected={selected}
                  setSelected={SetSelected}
                  sorting={sorting}
                  setSorting={(e) => {
                    setReload(true)
                    setSorting(e)
                  }}
                  isActionButton={{
                    ...(access.allowEdit && {
                      edit: toggleDrawer(true, "Edit"),
                    }),
                    ...(access.allowDelete && {
                      delete: toggleDrawer(true, "Delete"),
                    }),
                  }}
                />
              </Grid>
            </Box>
          </BaseLayout>
        </Grid>
      </Grid>

      {/* Add & Edit Currency Side Drawer */}
      <SideDrawer
        formComp={
          <AddEditCurrency
            state={state}
            setState={setState}
            crudState={crudState}
            formData={formData}
            setFormData={setFormData}
            // userId={null}
            hideSideDrawer={() => {
              setState({ right: false });
              getCurrencyData();
            }}
          />
        }
        state={state}
        setState={setState}
      />

      {/* Alert Dialog - Confirmation for Delete */}
      {openDelete ? (
        <AlertDialog
          open={openDelete}
          title={"Confirmation"}
          maxWidth={"sm"}
          description={`Are you sure you want to delete the currency "${deleteCurrencyData?.name}" ?`}
          action={
            <>
              <Grid container alignItems="center" justifyContent="right" spacing={2} className={classes.alertDialogbtn}>
                <Grid item xs={"auto"}>
                  <Button onClick={() => setOpenDelete(false)}>No</Button>
                </Grid>
                <Grid item xs={"auto"}>
                  <Button onClick={() => deleteCurrency()} color="secondary">
                    {deleteBtnLoadinng ? (<CircularProgress size={25} />) : ("Yes")}
                  </Button>
                </Grid>
              </Grid>
            </>
          }
        />
      ) : null
      }
    </Box >
  );
};

export default Currency;